import { useTranslation } from "react-i18next";
import popop_close from '../../assets/images/popop_close.png'; 


function ConfirmPopup(props) {
  const { content, reason, onReasonChange, reasonError, showReason = false  } = props;
  const { t } = useTranslation();
  return (
    <>
      <div className="text">{content}</div>
      {showReason && (
        <>
          <textarea
            className=""
            type="text"
            id="reason"
            name="reason"
            rows="5"
            value={reason}
            onChange={onReasonChange}
            placeholder={t("reason_for_reject")}
          ></textarea>
          {reasonError && <div className="error-inline error-inline-input">{reasonError}</div>}
        </>
      )}
      <div className="yesnobtn">
        <img className="popup_close" src={popop_close} onClick={props.cancel} alt="" width="43" height="43" />
        <button className="whitebtn proceed" onClick={props.confirm}>{t("proceed")}</button>
        <button className="whitebtn cancelbtn" onClick={props.cancel}>{t("cancel")}</button>
      </div>
    </>
  );
}

export default ConfirmPopup;
